import './Tabs.scss';

function Tabs(props) {
	return (
		<div className="Tabs">
			<ul>
				{props.tabs.map((tab, key) => {
					return (
						<li
							key={key}
							className={'tab ' + (props.activeTab === tab.key ? 'active' : '')}
							onClick={() => props.onChange(tab.key)}
						>
							{tab.label}
						</li>
					);
				})}
			</ul>
		</div>
	);
}

export default Tabs;
